import { useEffect, useState } from "react";
import {
  AutocompleteInput,
  ReferenceInput,
  useDataProvider,
  useRecordContext,
} from "react-admin";
import { useWatch } from "react-hook-form";

// OptionRenderer khusus untuk bonus product dari sale order
export const BonusProductOptionRenderer = () => {
  const record = useRecordContext();
  if (!record) return null;
  
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <span key="code" style={{ fontWeight: "500" }}>{record.code}</span>
      <span key="name" style={{ flex: 1 }}>{record.name}</span>
      <span key="remaining" style={{ fontSize: "0.875rem", color: "#666" }}>
        Sisa: {record.order_qty - record.sold_qty}
      </span>
    </div>
  );
};

const inputText = (choice) => {
  if (!choice) return "";
  return choice.code || "";
};

const matchSuggestion = (filter, choice) => {
  if (!choice || !choice.code) {
    return false;
  }
  const filterLower = filter.toLowerCase();
  return (
    choice.code.toLowerCase().includes(filterLower) ||
    (choice.name && choice.name.toLowerCase().includes(filterLower))
  );
};
const filterToQuery = (searchText) => ({ all: searchText });

const BonusProductFromSaleOrderReference = ({
  dependOn, // sale_order_id
  source, // bonus_product_id
  ...props
}) => {
  const saleOrderId = useWatch({ name: dependOn });

  console.log("BonusProductFromSaleOrderReference - saleOrderId:", saleOrderId);
  console.log("BonusProductFromSaleOrderReference - source:", source);

  return (
    <ReferenceInput
      source={source}
      reference="sale-order-items"
      perPage={100}
      sort={{
        field: "sale_order_items.code",
        order: "ASC",
      }}
      filter={{ sale_order_id: saleOrderId }}
      enableGetChoices={(filters) => {
        console.log("enableGetChoices filters:", filters);
        return !!saleOrderId;
      }}
    >
      <AutocompleteInput
        variant="outlined"
        fullWidth
        sx={{ display: "inline-flex" }}
        optionValue="product_id"
        optionText={<BonusProductOptionRenderer />}
        inputText={inputText}
        matchSuggestion={matchSuggestion}
        filterToQuery={filterToQuery}
        {...props}
      />
    </ReferenceInput>
  );
};

export default BonusProductFromSaleOrderReference;
